/** @jsxImportSource theme-ui */
import React from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'

import { Container } from '../../components/PageLayout/Container'
import { LayoutDetailsCard } from './LayoutDetailsCard'
import { LayoutProducts } from './LayoutProducts'
import { getLayout } from '../../utils/api'
import { Breadcrumbs } from '../../components/PageLayout/Breadcrumbs'

export function LayoutDetail() {
  const { id } = useParams()
  const { isIdle, isLoading, isError, data, error } = useQuery(
    ['layouts', id],
    () => getLayout(id),
    {
      enabled: !!id,
      staleTime: 1000 * 60 * 5,
    }
  )

  return (
    <Container>
      {(isIdle || isLoading) && <h1>Loading...</h1>}
      {isError && <h1>{error.message}</h1>}
      {data?.data && (
        <React.Fragment>
          <Breadcrumbs data={data} />
          <div sx={{ display: 'flex', flexDirection: ['column', 'column', 'row'], gap: '16px' }}>
            <div sx={{ width: 'min(520px, 100%)', px: [0, '60px'] }}>
              <LayoutDetailsCard layout={data.data} />
              <p sx={{ mt: '12px', fontFamily: 'heading', fontSize: '0.938rem' }}>
                {data.data.description}
              </p>
            </div>
            <div sx={{ flex: 2 }}>
              <LayoutProducts collections={data.data.products} products={data.data._products} />
            </div>
          </div>
        </React.Fragment>
      )}
    </Container>
  )
}
